import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Outlet } from "react-router-dom";
import { apiSae } from "../services/api";
import { HomeContext } from "./ContextHome";

export const ElevatoriaContext = createContext({});

export const ElevatoriaProvider = () => {
  const { headerApi } = useContext(HomeContext);

  const [geradores, setGeradores] = useState([]);
  const [dadosControle, setDadosControle] = useState({});
  const [idBombasLoading, setidBombasLoading] = useState([]);
  const [eventos, setEventos] = useState({ results: [] });

  const [dadosPoco, setDadosPoco] = useState([]);
  const [dadosBomba, setDadosBomba] = useState([]);

  const [modalConfirmaBomba, setModalConfirmaBomba] = useState(false);
  const [modalConfirmaControler, setModalConfirmaControler] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpenBomba, setModalIsOpenBomba] = useState(false);
  const [modalEventosFalhas, setModalEventosFalhas] = useState(false);
  const [modalAvisosEmegencia, setModalAvisosEmegencia] = useState(false);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDateBomba, setSelectedDateBomba] = useState(new Date());

  const [idDataPoco, setIdDataPoco] = useState(0);
  const [idDataBomba, setIdDataBomba] = useState(0);

  const [dataPoco, setDataPoco] = useState([]);
  const [dataBomba, setDataBomba] = useState([]);

  const [modalRelatoriosOn, setModalRelatoriosOn] = useState(false);
  const [modalRelatorioBombaOn, setModalRelatorioBombaOn] = useState(false);

  const [reversoOn, setReversoOn] = useState(false);
  const [ligarReversoModal, ligarSetReversoModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const listarEventos = useCallback(async (id_estacao) => {
    try {
      const response = await apiSae.get(
        `alertas/Leitura/${id_estacao}`,
        headerApi
      );
      setEventos(response.data);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  }, [headerApi]);

  const aoListarGeradores = useCallback(async () => {
    try {
      const response = await apiSae.get("gerador/LeituraTodos", headerApi);
      setGeradores(response.data);
    } catch (error) {}
  }, [headerApi]);

  const fetchDadosBomba = useCallback(async (id_bomba, date) => {
    try {
      const response = await apiSae.get(
        `/grafico/bomba/${id_bomba}?data=${date}`,
        headerApi
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar dados do poço:", error);
    }
  }, [headerApi]);

  useEffect(() => {
    aoListarGeradores();
  }, [aoListarGeradores]);

  return (
    <ElevatoriaContext.Provider
      value={{
        geradores,
        dadosControle,
        setDadosControle,
        modalConfirmaBomba,
        setModalConfirmaBomba,
        idBombasLoading,
        setidBombasLoading,
        modalIsOpen,
        setModalIsOpen,
        modalIsOpenBomba,
        setModalIsOpenBomba,
        modalEventosFalhas,
        setModalEventosFalhas,
        selectedDate,
        setSelectedDate,
        selectedDateBomba,
        setSelectedDateBomba,
        eventos,
        setEventos,
        listarEventos,
        fetchDadosBomba,
        dadosPoco,
        setDadosPoco,
        idDataPoco,
        setIdDataPoco,
        dataPoco,
        setDataPoco,
        dadosBomba,
        setDadosBomba,
        idDataBomba,
        setIdDataBomba,
        dataBomba,
        setDataBomba,
        modalConfirmaControler,
        setModalConfirmaControler,
        modalAvisosEmegencia,
        setModalAvisosEmegencia,
        modalRelatorioBombaOn,
        setModalRelatorioBombaOn,
        reversoOn,
        setReversoOn,
        ligarReversoModal,
        ligarSetReversoModal,
        loading,
        setLoading,
        modalRelatoriosOn,
        setModalRelatoriosOn,
      }}
    >
      <Outlet />
    </ElevatoriaContext.Provider>
  );
};
